import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../i18n';
import axios from 'axios';

const TranslationContext = createContext();

export const useTranslationContext = () => useContext(TranslationContext);

export const TranslationProvider = ({ children }) => {
    const [isTranslationLoading, setIsTranslationLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchTranslations = async () => {
            try {
                const apiStrapiUrl = process.env.REACT_APP_STRAPI_API;
                // We use a direct axios call here because we might need translations before the user is logged in (no token)
                // Adjust endpoint if your Strapi setup is different (e.g. /api/app-translation)
                const response = await axios.get(`${apiStrapiUrl}app-translation`);

                // Assumes Structure: { data: { attributes: { content: { ... } } } }
                // Or if it's a direct JSON response: { content: { ... } }
                // Adjust based on actual Strapi response structure for Single Type
                const translations = response.data?.data?.attributes?.content || response.data?.content || {};

                if (Object.keys(translations).length > 0) {
                    i18n.addResourceBundle('en', 'translation', translations, true, true);
                } else {
                    console.warn('No translations found in Strapi response');
                }

            } catch (err) {
                console.error('Error fetching translations from Strapi:', err);
                setError(err);
                // Optional: Load fallback translations here if fetch fails
            } finally {
                setIsTranslationLoading(false);
            }
        };
        fetchTranslations();
    }, []);

    return (
        <TranslationContext.Provider value={{ isTranslationLoading, error }}>
            {isTranslationLoading ? null : children}
        </TranslationContext.Provider>
    );
};

TranslationProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
